<template>
    <div class="main cycleitem">
        <cycle-card :course="cardInfo"></cycle-card>
        <div class="model-box mtm bcw">
            <div class="model-box__hd clear">
                <h3>卡片说明</h3>
                <div class="fs2 ptm blue">
                <router-link :to="{ name: 'venue',params:{clubId:cardInfo.clubId}}" class="blue">
                    【所属俱乐部：
                    {{cardInfo.clubTitle}}】
                </router-link>
                </div>
            </div>
            <div class="model-box__bd fs2 c6 mtm clear" v-html="cardInfo.about">
            </div>
        </div>
        <the-buybar :price="params.price" :oprice="params.oprice" :id="params.id" :isBuy="params.isBuy" :type="params.type"></the-buybar>
    </div>
</template>
<script>
import Vue from 'vue';
import { Button,Toast } from 'vant';
import CycleCard from '@/components/CycleCard';
import TheBuybar from '@/components/TheBuybar';
Vue.use(Button).use(Toast);

export default {
    name: 'CycleItem',
    components: {
        CycleCard,TheBuybar
    },
    data(){
      return {
        cardInfo:{}, //卡信息
        params: {},   //  支付按钮组件所需参数
      }
    },
    created(){
        // 取团课列表数据
        let _this = this;  //?为什么直接用this会报错？？
        this.$http.get('product/getClubCardInfo?productId=' + this.$route.params.courseId).then(function(res){
            if(!res.data.code){
                _this.cardInfo = res.data.value
                _this.params.id = _this.cardInfo.id

                if(_this.cardInfo.type=="MONTH_CARD"){
                    _this.params.type = 'clubMonthCard'  //月卡
                }else if(_this.cardInfo.type=="DAYS_CARD"){
                    _this.params.type = 'clubPracticeCard'  //练球卡
                }
                _this.params.price = _this.cardInfo.price
                _this.params.oprice = _this.cardInfo.originPrice
                _this.params.isBuy = false
            }else{
                Toast.fail(res.data.message)
            }
            
        })
    }

}
</script>
<style lang="less">
.cycleitem{
    margin: 0 .15rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/CycleItem.vue